import { useState } from 'react';
import { useWallpaper } from './store.ts';
import type { Wallpaper as WallpaperEntry } from './index.ts';

/**
 * The picture behind the desk, drawn as the first child of a shell (`.shell`, `.launcher`, `.auth`).
 * `object-fit: cover` crops instead of letterboxing, so any window size or aspect ratio is filled.
 */
export function Wallpaper() {
  const wallpaper = useWallpaper();
  // Keyed so a new choice fades in from its own base colour instead of reusing the old picture's loaded state.
  return wallpaper && <WallpaperLayer key={wallpaper.id} wallpaper={wallpaper} />;
}

function WallpaperLayer({ wallpaper }: { wallpaper: WallpaperEntry }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="wallpaper" data-tone={wallpaper.tone} data-loaded={loaded || undefined} aria-hidden>
      <img
        // A cached image can be complete before React attaches onLoad.
        ref={(img) => {
          if (img?.complete && img.naturalWidth > 0) setLoaded(true);
        }}
        src={wallpaper.full}
        srcSet={`${wallpaper.small} 960w, ${wallpaper.full} ${wallpaper.width}w`}
        sizes="100vw"
        width={wallpaper.width}
        height={wallpaper.height}
        alt=""
        decoding="async"
        draggable={false}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
